import { render, staticRenderFns } from "./DocumentRelevanceDecisionBar.vue?vue&type=template&id=354e53b9&scoped=true&"
import script from "./DocumentRelevanceDecisionBar.vue?vue&type=script&lang=js&"
export * from "./DocumentRelevanceDecisionBar.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRelevanceDecisionBar.vue?vue&type=style&index=0&id=354e53b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e53b9",
  null
  
)

export default component.exports